import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { FC } from 'react';

const PreLoader: FC<{
  size?: 'large' | 'small' | 'default';
}> = ({ size = 'default' }) => (
  <Spin
    indicator={<LoadingOutlined />}
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    size={size}
    spinning
  />
);

export default PreLoader;
